import { useMainButtonFallback } from '../telegram/ui';

/** HTML-замена нативной MainButton вне Telegram (dev в браузере, e2e). */
export function MainButtonFallback({
  text,
  onClick,
  disabled = false,
  visible = true,
}: {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  visible?: boolean;
}) {
  const show = useMainButtonFallback();
  if (!show || !visible) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 bg-bg p-3">
      <button
        type="button"
        data-testid="main-button"
        disabled={disabled}
        onClick={onClick}
        className="w-full rounded-xl bg-button px-4 py-3 text-base font-semibold text-button-text disabled:opacity-50"
      >
        {text}
      </button>
    </div>
  );
}
